import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import { Dropdown, DropdownToggle } from 'reactstrap';
import { useToggle } from '@availity/hooks';
import FeedbackDropdown from './FeedbackDropdown';
import FeedbackModal from './FeedbackModal';

var Feedback = function Feedback(_ref) {
  var appName = _ref.appName,
      modal = _ref.modal,
      children = _ref.children,
      className = _ref.className,
      outline = _ref.outline,
      color = _ref.color,
      formProps = _ref.formProps,
      prompt = _ref.prompt,
      onFeedbackSent = _ref.onFeedbackSent,
      props = _objectWithoutPropertiesLoose(_ref, ["appName", "modal", "children", "className", "outline", "color", "formProps", "prompt", "onFeedbackSent"]);

  var _useToggle = useToggle(false),
      isOpen = _useToggle[0],
      _toggle = _useToggle[1];

  return React.createElement(Dropdown, Object.assign({
    isOpen: isOpen && !modal,
    toggle: function toggle() {
      return _toggle();
    },
    className: className + " hidden-print"
  }, props), React.createElement(DropdownToggle, {
    color: color,
    outline: outline
  }, children || 'Give Feedback'), modal ? React.createElement(FeedbackModal, Object.assign({
    onFeedbackSent: onFeedbackSent,
    prompt: prompt,
    isOpen: isOpen,
    toggle: function toggle() {
      return _toggle();
    },
    name: appName
  }, formProps)) : React.createElement(FeedbackDropdown, Object.assign({
    onFeedbackSent: onFeedbackSent,
    prompt: prompt,
    toggle: function toggle() {
      return _toggle();
    },
    name: appName
  }, formProps)));
};

Feedback.defaultProps = {
  modal: false,
  color: 'light'
};
export default Feedback;